import { Card } from "@/components/ui/card";

export function ThinkingMessageComponent() {
  return (
    <Card className="p-4 bg-card rounded-lg shadow-sm max-w-20">
      <div className="flex items-center gap-1">
        <div className="w-2 h-2 bg-foreground/60 rounded-full animate-bounce [animation-delay:-0.3s]" />
        <div className="w-2 h-2 bg-foreground/60 rounded-full animate-bounce [animation-delay:-0.15s]" />
        <div className="w-2 h-2 bg-foreground/60 rounded-full animate-bounce" />
      </div>
    </Card>
  );
}
